import { CheckCircle2, Video, BarChart2, FileSearch, Eye } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const PILLARS = [
{ icon: Video, title: "Video Updates from On-Ground", desc: "Regular walkthrough videos from our field team, so you see exactly what's happening at your property, even from 10,000 km away." },
{ icon: FileSearch, title: "Detailed Maintenance Reports", desc: "Every repair, every issue, documented with before and after evidence, costs, and vendor notes." },
{ icon: BarChart2, title: "Monthly Performance Summaries", desc: "Clear, concise monthly statements covering rent received, expenses incurred, and net returns." },
{ icon: Eye, title: "Comprehensive Property Analytics", desc: "Deeper insights into your asset's health, market positioning, rental yield trends, and condition score." }];


export function WhyChooseUs() {
  return (
    <section className="relative py-32 overflow-hidden" data-testid="why-choose-us-section">
      <div className="container-luxury">
        <div className="grid gap-16 lg:grid-cols-2 lg:gap-24 items-center">
          <Reveal y={40}>
            <div className="relative h-[600px]">
              <div className="absolute left-0 top-0 h-[440px] w-[80%] overflow-hidden rounded-2xl shadow-luxury-lg">
                <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=85" alt="Premium interior living room" className="absolute inset-0 h-full w-full object-cover" />
              </div>
              <div className="absolute bottom-0 right-0 h-[300px] w-[60%] overflow-hidden rounded-2xl shadow-luxury border-4 border-white">
                <img src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=700&q=85" alt="Luxury villa exterior" className="absolute inset-0 h-full w-full object-cover" />
              </div>
              <div className="absolute left-[72%] top-[38%] -translate-x-1/2 -translate-y-1/2 z-10 rounded-full bg-gold-400 px-5 py-3 shadow-luxury">
                <p className="text-center text-xs font-semibold uppercase tracking-wider text-navy-900">Full<br />Transparency</p>
              </div>
            </div>
          </Reveal>

          <div>
            <SectionHeading eyebrow="Why Choose Us" title="We Show You" titleAccent="Everything" subtitle="Our transparency promise isn't a marketing claim — it's the operating model. You'll always know exactly what's happening with your asset." align="left" />
            <div className="mt-12 grid gap-6">
              {PILLARS.map((pillar, i) => {
                const Icon = pillar.icon;
                return (
                  <Reveal key={pillar.title} delay={0.1 + i * 0.1}>
                    <div className="flex gap-4">
                      <div className="mt-0.5 shrink-0 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-50 text-emerald-500">
                        <Icon size={18} strokeWidth={1.5} />
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-navy-800 tracking-tight">{pillar.title}</h3>
                        <p className="mt-1.5 text-sm leading-relaxed text-navy-600/70">{pillar.desc}</p>
                      </div>
                    </div>
                  </Reveal>);

              })}
            </div>
            <Reveal delay={0.5}>
              <div className="mt-12 flex flex-wrap gap-3">
                {["No Hidden Charges", "Performance-Aligned Fees", "POA-Friendly", "25+ Year Legacy"].map((badge) =>
                <span key={badge} className="inline-flex items-center gap-1.5 rounded-full border border-navy-100 bg-stone-50 px-4 py-2 text-xs font-medium text-navy-700">
                    <CheckCircle2 size={12} className="text-emerald-500" />{badge}
                  </span>
                )}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>);

}